import { render } from "./price-vat-tip.vue?vue&type=template&id=dfe4a97e"
import script from "./price-vat-tip.vue?vue&type=script&lang=js"
export * from "./price-vat-tip.vue?vue&type=script&lang=js"

import "./price-vat-tip.vue?vue&type=style&index=0&id=dfe4a97e&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__